import { render, staticRenderFns } from "./quotation-offer.vue?vue&type=template&id=0f88fe10"
import script from "./quotation-offer.vue?vue&type=script&lang=js"
export * from "./quotation-offer.vue?vue&type=script&lang=js"
import style0 from "./quotation-offer.vue?vue&type=style&index=0&id=0f88fe10&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f88fe10')) {
      api.createRecord('0f88fe10', component.options)
    } else {
      api.reload('0f88fe10', component.options)
    }
    module.hot.accept("./quotation-offer.vue?vue&type=template&id=0f88fe10", function () {
      api.rerender('0f88fe10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-offer.vue"
export default component.exports